import ReduxActionInterface from '../../model/ReduxActionInterface';
import ReduxRootState from '../../model/Redux/ReduxRootSate';
import * as ActionTypeWithDraw from './actionsType';

const ROOT_VALUE_STATE: ReduxRootState = {
    loading: false,
    data: {},
};

export const withdrawsAcceptRefuseReducer = (state: ReduxRootState = ROOT_VALUE_STATE, action: ReduxActionInterface) => {

    switch (action.type) {
        case ActionTypeWithDraw.ACCEPT_REFUSE_WITHDRAWS_LOADING:
            return {
                ...state,
                loading: true,
            };

        case ActionTypeWithDraw.ACCEPT_REFUSE_WITHDRAWS_ERROR:

            return {
                ...state,
                loading: false,
            };

        case ActionTypeWithDraw.ACCEPT_REFUSE_WITHDRAWS_SUCCESS:

            return {
                data: action.payload,
                loading: false,
            };


        default: return state;

    }
};
